// ブラウザタブに出すページタイトルの組み立て。 SPA (ssr: false) なので SEO ではなく
// タブ / 履歴 / ブックマークの識別が目的。
export const SITE_TITLE = "Contents Edit System";

// ページ名が空 / サイト名と同じ場合は重複させない。
export const buildPageTitle = (pageTitle: string): string =>
    pageTitle !== "" && pageTitle !== SITE_TITLE ? `${pageTitle} | ${SITE_TITLE}` : SITE_TITLE;
